import { useEffect } from "react";

// syntactic sugar for useEffect(() => {}, [])
export const useMountEffect = (effect: () => void): void => {
  useEffect(() => {
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
